
<ng-container *ngIf="!isMobile; else mobileFilters">
<div [formGroup]="form" class="flex justify-between my-3 space-x-2 w-full">
  <div class="flex space-x-3">
    <!-- SEARCH FIRST -->
    <div *ngIf="showSearch">
      <div class="relative rounded-md shadow-sm">
        <input 
          *ngIf="!searchInputAdjustWidth" type="text" name="search" id="search" formControlName="frmSearch" 
          class="inputTextoDialog focusCampo !h-10 pr-10 w-full border border-gray-300 rounded-md" 
          style="margin-right: 4.5vw;"
          [placeholder]="searchInputPlaceHolder"
        >
    
        <input 
          *ngIf="searchInputAdjustWidth" type="text" name="search" id="search" formControlName="frmSearch" 
          class="inputTextoDialog focusCampo !h-10 pr-10 w-full border border-gray-300 rounded-md" 
          style="margin-right: 4.5vw;"
          [placeholder]="searchInputPlaceHolder" 
          [size]="searchInputPlaceHolder.length"
        >
    
        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
          <span 
            class="text-gray-500 sm:text-sm pointer-events-none opacity-50" 
            *ngIf="form && !form.get('frmSearch')!.value"
          >
            <esp-icon icon="faSearch"></esp-icon>
          </span>
    
          <span 
            class="text-gray-500 sm:text-sm cursor-pointer hover:text-gray-700 focus:text-gray-700" 
            *ngIf="form && form.get('frmSearch')!.value" 
            (click)="clearSearch()"
          >
            <esp-icon icon="faTimes"></esp-icon>
          </span>
        </div>
      </div>
    </div>
    <!-- THEN DATE FILTER -->
    <div *ngIf="showDateFilter && !restartFilterDate" class="relative rounded-md !h-9 shadow-sm" [cdkMenuTriggerFor]="prueba.menu">
      <span *ngIf="labelDateFilter" class="text-gray-700 text-sm font-medium">
        {{labelDateFilter}}
      </span>
      <div class="relative">

        <input  type="text" name="searchdate" id="searchDate" readonly formControlName="frmSearchDate"
        style="padding-left: 2.0rem; padding-right: 1.75rem; margin-right: 4.5vw;"
        class="inputTextoDialog focusCampo h-10 pr-10 pl-10 w-full border border-gray-300 rounded-md" placeholder="Filtrar por fechas">
          <!-- Icono del calendario a la izquierda -->
    <ng-container *ngIf="form">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <span datepicker class="text-gray-500 sm:text-sm">
          <esp-icon icon="faCalendarAlt"></esp-icon>
        </span>
      </div>
    
      <!-- Icono de cierre a la derecha, visible solo si hay valor en el input -->
      <div class="absolute inset-y-0 right-0 flex items-center pr-3">
        <span 
          class="text-gray-500 sm:text-sm cursor-pointer hover:text-gray-700 focus:text-gray-700"
          (click)="clearDate($event)"
          *ngIf="form.get('frmSearchDate')!.value"
        >
          <esp-icon icon="faTimes"></esp-icon>
        </span>
      </div>
    </ng-container>

      </div>

      <esp-filtro-fecha
      [setSelectionBg]="setFilterDateSelectionBg"
      [setButtonBg]="setFilterDateButtonBg"
      [setOptionSelected]="setFilterDateOptionSelected"
      [setTextColour]="setFilterDateTextColour"
      [setDateSelectedDefault]="setDateSelectedDefault"
      (sendDateFilter)="setDateFilter($event)"
      (sendDateFilterWithCeros)="setDateFilterWithCeros($event)"
      (sendDateFilterWithoutCeros)="setDateFilterWithoutCeros($event)"
      (sendDateFilterUSDate)="setDateFilterUSDate($event)"
      #prueba></esp-filtro-fecha>
    </div>

  </div>
  <div class="flex space-x-3 items-center">
    <div *ngIf="menuOpt.length > 0 && firstMenuOpt">
      <app-btn color="bordeado" [cdkMenuTriggerFor]="accionesMenu"> <div class="flex flex-row gap-2"><span>Acciones</span><esp-icon icon="faBars"></esp-icon></div></app-btn>
      <ng-template #accionesMenu>
        <div class="menu-layout botonApariencia" cdkMenu>
          <button *ngFor="let opcion of menuOpt, index as i" cdkMenuItem class="flex flex-row gap-2.5 text-[var(--color-black-alt)] px-2.5 py-2 hover:bg-gray-100" (click)="i == 0 ? primerActionMenu.emit() : (i == 1 ? segundoActionMenu.emit() : tercerActionMenu.emit())">
            <span class="text-[16px] font-medium">{{opcion.texto}}</span>
            <img [src]="opcion.svgDir"/>
          </button>
        </div>
      </ng-template>
    </div>
    <div *ngIf="showThirdDisplayFilter">
      <div class="relative rounded-md shadow-sm">
        <select id="acciones" #secondSelect class="bg-white border border-gray-300 !h-10 text-gray-600 text-sm rounded-lg focusCampo block w-full" (change)='changeThirdFilter(secondSelect.value)'>
          <option *ngIf="thirdDisplayFilterPlaceholder.indicador == true" [value]="null" selected>{{thirdDisplayFilterPlaceholder.placeholder}}</option> 
          <option *ngIf="thirdDisplayFilterPlaceholder.indicador == false" disabled selected>{{thirdDisplayFilterPlaceholder.placeholder}}</option>
          
          <option *ngFor="let option of thirdDisplayFilterData" [value]='option._id'>{{option.valor | titlecase}}</option>
        </select>
      </div>
    </div>
    <div *ngIf="showSecondDisplayFilter">
      <div class="relative rounded-md shadow-sm">
        <select id="acciones" #secondSelect class="bg-white border border-gray-300 !h-10 text-gray-600 text-sm rounded-lg focusCampo block w-full" (change)='changeSecondFilter(secondSelect.value)'>
          <option *ngIf="secDisplayFilterPlaceholder.indicador == true" [value]="null" selected>{{secDisplayFilterPlaceholder.placeholder}}</option> 
          <option *ngIf="secDisplayFilterPlaceholder.indicador == false" disabled selected>{{secDisplayFilterPlaceholder.placeholder}}</option>
          
          <option *ngFor="let option of secDisplayFilterData" [value]='option._id'>{{option.valor | titlecase}}</option>
        </select>
      </div>
    </div>
    <div *ngIf="showFirstDisplayFilter">
        <div class="relative rounded-md shadow-sm">
          <select id="docs" #firstSelect class="bg-white border border-gray-300 text-gray-600 text-sm rounded-lg focusCampo !h-10 block w-full" (change)='changeFirstFilter(firstSelect.value)'>
            <option *ngIf="firstDisplayFilterPlaceholder.indicador == true" [value]="null">{{firstDisplayFilterPlaceholder.placeholder}}</option> 
            <option *ngIf="firstDisplayFilterPlaceholder.indicador == false" disabled selected>{{firstDisplayFilterPlaceholder.placeholder}}</option>
            
            <option *ngFor="let option of firstDisplayFilterData" [value]='option._id' [id]="'option_' + option._id" [selected]="(firstDisplaySelectedValue) ? true : false">{{option.valor | titlecase}}</option>
          </select>
        </div>
    </div>
    <div *ngIf="showDynamicSearch" class="relative w-[300px]">
      <!-- Campo de Búsqueda -->
      <div class="relative">
        <input
          type="text"
          class=" focusCampo !h-10 pr-10  pl-10 w-full border border-gray-300 rounded-md text-[15px]"
          [formControl]="searchControl"
          [placeholder]="searchInputAutocompletePlaceHolder"
          [matAutocomplete]="autoSearch"
          [readOnly]="selectedItem"
          [ngClass]="selectedItem ? 'bg-gray-200' : ''"
        />
        
        <!-- Ícono en el lado izquierdo -->
        <div class="absolute inset-y-0 left-0 flex items-center pl-3">
          <img src="assets/svg/gray-search.svg" class="h-5 w-5" />
        </div>
    
        <!-- Ícono en el lado derecho -->
        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
          <img 
            src="assets/svg/close-modal.svg" 
            class="h-3 w-3 cursor-pointer" 
            *ngIf="selectedItem" 
            (click)="resetSearch()" 
          />
        </div>
      </div>
      
    
      <!-- Resultados del Autocomplete -->
      <mat-autocomplete #autoSearch="matAutocomplete" (optionSelected)="selectSearchItem($event.option.value)">
        <mat-option *ngFor="let result of searchResults" [value]="result">
          {{ result.name || result.nombre || result.valor || result.descripcion || 'Elemento' }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div *ngIf="menuOpt.length > 0 && !firstMenuOpt">
      <app-btn color="bordeado" [cdkMenuTriggerFor]="accionesMenu"> <div class="flex flex-row gap-2"><span>Acciones</span><esp-icon icon="faBars"></esp-icon></div></app-btn>
      <ng-template #accionesMenu>
        <div class="menu-layout botonApariencia" cdkMenu>
          <button *ngFor="let opcion of menuOpt, index as i" cdkMenuItem class="flex flex-row gap-2.5 text-[var(--color-black-alt)] px-2.5 py-2 hover:bg-gray-100" (click)="i == 0 ? primerActionMenu.emit() : (i == 1 ? segundoActionMenu.emit() : tercerActionMenu.emit())">
            <span class="text-[16px] font-medium">{{opcion.texto}}</span>
            <img [src]="opcion.svgDir"/>
          </button>
        </div>
      </ng-template>
    </div>
    
    
    
    
    
    
    <div *ngIf="showButton">
        <div class="relative rounded-md">
          <app-btn 
            color="brand-gradient"
            [style]="{ 'inline-flex': true, 'items-center': true, 'gap-2': true }"
            (click)="buttonAccion.emit()"
          >
            <esp-icon icon="faAdd"></esp-icon>
            {{buttonText}}
          </app-btn>
        </div>
    </div>

  </div>
</div>

</ng-container>

<ng-template #mobileFilters>
  <!-- CONTENIDO MOBILE AQUÍ -->
  <div [formGroup]="form" class="flex flex-col gap-2 w-full mt-3">
    <!-- FILTRO DE FECHA -->
    <div *ngIf="showDateFilter && !restartFilterDate" class="relative" [cdkMenuTriggerFor]="prueba.menu">
      <label *ngIf="labelDateFilter" class="text-gray-700 text-sm font-medium">{{labelDateFilter}}</label>
      <div class="relative w-full">
         <!-- Input con padding a la izquierda para dejar espacio al ícono -->
        <input
          type="text"
          readonly
          formControlName="frmSearchDate"
          class="inputTextoDialogMobile focusCampo h-10 pl-10 pr-3 w-full border border-gray-300 rounded-md"
          placeholder="Filtrar por fechas"
        />

        <!-- Ícono de calendario a la izquierda, dentro del input -->
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-500">
          <esp-icon icon="faCalendarAlt"></esp-icon>
        </div>
        <div class="absolute inset-y-0 right-0 flex items-center pr-3" *ngIf="form.get('frmSearchDate')!.value">
          <span (click)="clearDate($event)" class="text-gray-500 sm:text-sm cursor-pointer">
            <esp-icon icon="faTimes"></esp-icon>
          </span>
        </div>
      </div>
      <esp-filtro-fecha
        [setSelectionBg]="setFilterDateSelectionBg"
        [setButtonBg]="setFilterDateButtonBg"
        [setOptionSelected]="setFilterDateOptionSelected"
        [setTextColour]="setFilterDateTextColour"
        [setDateSelectedDefault]="setDateSelectedDefault"
        (sendDateFilter)="setDateFilter($event)"
        (sendDateFilterWithCeros)="setDateFilterWithCeros($event)"
        (sendDateFilterWithoutCeros)="setDateFilterWithoutCeros($event)"
        (sendDateFilterUSDate)="setDateFilterUSDate($event)"
        #prueba>
      </esp-filtro-fecha>
    </div>

    <!-- BÚSQUEDA SIMPLE -->
    <div *ngIf="showSearch" class="relative">
      <input type="text" formControlName="frmSearch"
        class="inputTextoDialog focusCampo h-10 pr-10 w-full border border-gray-300 rounded-md"
        [placeholder]="searchInputPlaceHolder">
      <div class="absolute inset-y-0 right-0 flex items-center pr-3">
        <span *ngIf="!form.get('frmSearch')!.value" class="text-gray-500 opacity-50">
          <esp-icon icon="faSearch"></esp-icon>
        </span>
        <span *ngIf="form.get('frmSearch')!.value" (click)="clearSearch()" class="text-gray-500 cursor-pointer">
          <esp-icon icon="faTimes"></esp-icon>
        </span>
      </div>
    </div>
    
    <!-- BUSCADOR DINÁMICO -->
    <div *ngIf="showDynamicSearch" class="relative">
      <input type="text" [formControl]="searchControl"
        class="focusCampo h-10 pr-10 pl-10 w-full border border-gray-300 rounded-md text-sm"
        [placeholder]="searchInputAutocompletePlaceHolder" [matAutocomplete]="autoSearch" [readOnly]="selectedItem">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3">
        <img src="assets/svg/gray-search.svg" class="h-5 w-5" />
      </div>
      <div class="absolute inset-y-0 right-0 flex items-center pr-3" *ngIf="selectedItem">
        <img src="assets/svg/close-modal.svg" class="h-3 w-3 cursor-pointer" (click)="resetSearch()" />
      </div>
      <mat-autocomplete #autoSearch="matAutocomplete" (optionSelected)="selectSearchItem($event.option.value)">
        <mat-option *ngFor="let result of searchResults" [value]="result">
          {{ result.name || result.nombre || result.valor || result.descripcion || 'Elemento' }}
        </mat-option>
      </mat-autocomplete>
    </div>

    <!-- SELECTS (SE MOSTRARÁN UNO BAJO OTRO) -->
    <!-- FILTROS Y ACCIONES EN DOS COLUMNAS -->
<!-- GRILLA RESPONSIVA PARA FILTROS Y ACCIONES -->
<div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
  <!-- SELECT 1 -->
  <div class="col-span-1" *ngIf="showFirstDisplayFilter">
    <select class="w-full h-10 border border-gray-300 rounded-md text-sm text-gray-700 focusCampo"
      (change)="changeFirstFilter(firstSelect.value)" #firstSelect>
      <option *ngIf="firstDisplayFilterPlaceholder.indicador" [value]="null">{{firstDisplayFilterPlaceholder.placeholder}}</option>
      <option *ngIf="!firstDisplayFilterPlaceholder.indicador" disabled selected>{{firstDisplayFilterPlaceholder.placeholder}}</option>
      <option *ngFor="let option of firstDisplayFilterData" [value]="option._id">{{option.valor | titlecase}}</option>
    </select>
  </div>

  <!-- SELECT 2 -->
  <div class="col-span-1" *ngIf="showSecondDisplayFilter">
    <select class="w-full h-10 border border-gray-300 rounded-md text-sm text-gray-700 focusCampo"
      (change)="changeSecondFilter(secondSelect.value)" #secondSelect>
      <option *ngIf="secDisplayFilterPlaceholder.indicador" [value]="null">{{secDisplayFilterPlaceholder.placeholder}}</option>
      <option *ngIf="!secDisplayFilterPlaceholder.indicador" disabled selected>{{secDisplayFilterPlaceholder.placeholder}}</option>
      <option *ngFor="let option of secDisplayFilterData" [value]="option._id">{{option.valor | titlecase}}</option>
    </select>
  </div>

  <!-- SELECT 3 -->
  <div class="col-span-1" *ngIf="showThirdDisplayFilter">
    <select class="w-full h-10 border border-gray-300 rounded-md text-sm text-gray-700 focusCampo"
      (change)="changeThirdFilter(thirdSelect.value)" #thirdSelect>
      <option *ngIf="thirdDisplayFilterPlaceholder.indicador" [value]="null">{{thirdDisplayFilterPlaceholder.placeholder}}</option>
      <option *ngIf="!thirdDisplayFilterPlaceholder.indicador" disabled selected>{{thirdDisplayFilterPlaceholder.placeholder}}</option>
      <option *ngFor="let option of thirdDisplayFilterData" [value]="option._id">{{option.valor | titlecase}}</option>
    </select>
  </div>

  <!-- BOTONES DE ACCIÓN VISIBLES EN LUGAR DE MENÚ -->
<!-- COLUMNA DE ACCIONES -->
<div class="col-span-1 sm:col-span-2 flex flex-row gap-2 justify-end" *ngIf="showButton || menuOpt.length > 0">
  <!-- Botón principal (como "+ Nuevo") -->
  <div class="w-full sm:w-2/3" *ngIf="showButton">
    <app-btn
      color="brand-gradient"
      [style]="{ '!text-sm': true, 'w-full': true, 'h-10': true, 'inline-flex': true, 'items-center': true, 'justify-center': true }"
      (click)="buttonAccion.emit()"
      >
      {{buttonText}}
    </app-btn>
  </div>
    <!-- FILA de botones de acción (solo íconos, como Excel) -->
  <div class="flex gap-2 flex-wrap" *ngIf="menuOpt.length > 0">
    <button
      *ngFor="let opcion of menuOpt; index as i"
      class="w-10 h-10 bg-white rounded hover:bg-gray-300 flex items-center justify-center"
      (click)="i == 0 ? primerActionMenu.emit() : (i == 1 ? segundoActionMenu.emit() : tercerActionMenu.emit())"
      [title]="opcion.texto"
    >
      <img [src]="opcion.svgDir" class="h-5 w-5" />
    </button>
  </div>
</div>
</div>
</div>
</ng-template>
